import {type FC, useState} from 'react';

import type {Props} from './types';

import {Text} from '../Text';
import * as S from './styles';

const RatingBar: FC<Props> = ({
  activeColor,
  labels,
  max,
  onChange,
  title,
  ...rest
}) => {
  const [rating, setRating] = useState(0);

  const handleRatingChange = (newRating: number) => {
    setRating(newRating);
    onChange(newRating);
  };

  return (
    <S.Container {...rest}>
      <Text weight="semibold">{title}</Text>
      <S.RatingBar>
        {Array.from({length: max}, (_, index) => index + 1).map(
          (value, i, itself) => {
            const isFirst = i === 0;
            const isLast = i === itself.length - 1;
            const isActive = value === rating;

            return (
              <S.Item key={value}>
                <S.NumberContainer
                  activeColor={activeColor}
                  isActive={isActive}
                  isFirst={isFirst}
                  isLast={isLast}
                  onClick={() => handleRatingChange(value)}
                >
                  <S.NumberText isActive={isActive}>{value}</S.NumberText>
                </S.NumberContainer>
                {labels[value] ? (
                  <S.Label isFirst={isFirst} isLast={isLast}>
                    {labels[value]}
                  </S.Label>
                ) : null}
              </S.Item>
            );
          },
        )}
      </S.RatingBar>
    </S.Container>
  );
};

export {RatingBar};
